import InfoBar from "../../../../info-paragraph/info-bar";
import React from "react";
import {toFrontDateTimeFromUTC} from "../../../../../util/util-dates";
import Card from "../../../../card";

export default function HoursOfService({data, translate}) {
    const hasData = !!data?.RemainingDriveTimeUntilNextBreak || !!data?.RemainingDriveTimeForTheDay || !!data?.RemainingOnDutyTimeForTheDay || !!data?.RemainingCycleTime || !!data?.LastHosUpdateDate;
    return <div className="my-8">
        <div className="font-bold leading-5 mb-2 text-base">
            Hours of Service
        </div>

        {!hasData && (
            <InfoBar>
                No Hours of Service information available for this driver
            </InfoBar>
        )}

        {hasData && (
            <Card>
                {data?.hosStatusType && (
                    <div className="text-base font-semibold py-2 px-4 mb-2">
                        {translate("text." + data?.hosStatusType)}
                    </div>
                )}

                <div
                    className="mx-auto grid grid-cols-1 gap-px sm:grid-cols-1 divide-x divide-y divide-tm-gray-200 border border-tm-gray-200 rounded-lg">
                    <HOSInfo
                        label="Remaining Drive Time for the Day"
                        value={data?.RemainingDriveTimeForTheDay}
                    />

                    <HOSInfo
                        label="Remaining On Duty Time for the Day"
                        value={data?.RemainingOnDutyTimeForTheDay}
                    />

                    <HOSInfo
                        label="Remaining Drive Time Until Next Break"
                        value={data?.RemainingDriveTimeUntilNextBreak}
                    />

                    <HOSInfo
                        label="Remaining Cycle Time"
                        value={data?.RemainingCycleTime}
                    />

                </div>

                {data?.LastHosUpdateDate && (
                    <InfoBar>
                        <div className="flex flex-col">
                            <div className="text-base font-semibold">Last
                                updated: {toFrontDateTimeFromUTC(data.LastHosUpdateDate)}</div>
                            Hours of service data is synced approximately every 10 min.
                        </div>
                    </InfoBar>
                )}
            </Card>
        )}
    </div>
}

function HOSInfo({label, value}) {
    if (!value) {
        return null;
    }

    const totalHours = Math.floor(value / 60);
    const minutes = value % 60;

    const time = `${totalHours} hours ${minutes} minutes`;

    return <div className="flex w-full px-4 py-1">

        <div className="text-sm/6 font-medium text-gray-500">{label}</div>

        <div className="ml-auto flex-none text-base font-medium tracking-tight text-gray-900">
            {time}
        </div>

    </div>
}